import ReactGA from "react-ga4";

export const logEvent = (
  eventType: string,
  event?: Record<string, object> | undefined
) => {
  if (process.env.NODE_ENV === "production")
    void ReactGA.event(eventType, event);
};
